<template>
  <div class="container">
    <br />
    <div class="buttons is-centered">
      <b-button
        size="is-medium"
        type="is-primary"
        v-for="event in eventType"
        :key="event.name"
        @click="logEvent(event)"
      >
        <span v-html="event.icon"></span>
      </b-button>
    </div>
    <span class="is-size-6 has-text-grey">Add Manually</span>
     <AddEvent :eventList="eventList" />
    <br />
    <div class="container mt-5">
      <p class="subtitle has-text-weight-semibold">Last {{rowsToShow}} Events</p>
      <LogTable :eventList="eventList" :rows="rowsToShow" @remove-row="updateList" :showDelete="showDelete" />
    </div>   
  </div>
</template>

<script>
import LogTable from '../components/LogTable'
import AddEvent from '../components/AddEvent'
import getLogs from '../helpers/fireBaseGet'
import addLogs from '../helpers/fireBaseAdd'
import db from '../fireBaseInit'

export default {
  components: {
    LogTable,
    AddEvent
  },
  data() {
    return {
      eventList: [],
      eventType: [
        { name: 'Feed', 'icon': '&#127868' },
        { name: 'Solid', 'icon': '&#128169' },
        { name: 'Liquid', 'icon': '&#128701' }
      ],
      rowsToShow: 7,
      showDelete: false,
      
    }
  },
  methods: {
    logEvent(e) {
      let ev = {
        'type': e.name,
        'timestamp': new Date()
      }
      addLogs(db, ev)
      this.eventList.push(ev)
    },
    updateList(newList){
      this.eventList = newList
    }
  },
  async created(){
    let loadData = await getLogs(db)
    loadData.forEach(x => {
      this.eventList.push({
        "id": x.id,
        "type": x.data().type,
        "timestamp": x.data().timestamp.toDate()
      })
    })
  }
  
}

</script>

<style>
button {
  font-size: 20px;
  margin: 10px;
}
</style>
